import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://kanbello.com";
const HOME_TITLE = "Kanbello | Kanban Project Management for Agile Teams";
const HOME_DESCRIPTION =
  "Plan sprints, organize tasks, and collaborate with your team using Kanbello's simple, mobile-friendly Kanban project management platform.";

const setMeta = (selector: string, attribute: string, value: string) => {
  const element = document.head.querySelector<HTMLMetaElement>(selector);
  if (element) element.setAttribute(attribute, value);
};

const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const isHomepage = pathname === "/";
    const title = isHomepage ? HOME_TITLE : "Kanbello";
    const description = isHomepage
      ? HOME_DESCRIPTION
      : "Secure Kanbello application page.";
    const canonicalUrl = isHomepage ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;

    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta(
      'meta[name="robots"]',
      "content",
      isHomepage
        ? "index, follow, max-image-preview:large"
        : "noindex, nofollow, noarchive"
    );
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    const canonical = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]'
    );
    if (canonical) canonical.href = canonicalUrl;
  }, [pathname]);

  return null;
};

export default SeoManager;
